export const serverError = {
  title: 'На сервере произошла непредсказуемая ошибка. Она вскоре будет исправлена',
  reloadPage: 'Обновить страницу',
  goMain: 'Вернуться на главную',
};
export default serverError;